<h1 mat-dialog-title>{{isNew ? 'Add comment' : 'Edit comment'}}{{data?.title ? ' on ' + data.title : ''}}</h1>

<mat-dialog-content>
    <p class="intro">Line breaks are kept. You can also use simple html such as &lt;b&gt;bold&lt;/b&gt; and &lt;i&gt;italic&lt;/i&gt;.</p>

    <mat-form-field class="full">
        <mat-label>Comment</mat-label>
        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="12" placeholder="What stands out in this section?"
            [formControl]="commentControl" [maxlength]="COMMENT_MAX" id="comment-text" cdkFocusInitial></textarea>
        <mat-hint align="end">{{commentControl.value.length}}/{{COMMENT_MAX}}</mat-hint>
        @if (commentControl.hasError('maxlength')) {
            <mat-error>Comments must be {{COMMENT_MAX}} characters or fewer</mat-error>
        }
    </mat-form-field>

    @if (preview) {
        <div class="preview-label">Preview</div>
        <p class="preview" [innerHTML]="preview"></p>
    }
    @if (data?.note) {
        <p class="intro">{{data.note}}</p>
    }
</mat-dialog-content>

<mat-dialog-actions>
    @if (!isNew) {
        <button mat-button color="warn" (click)="onRemove()">Remove</button>
    }
    <span class="spacer"></span>
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="accent" (click)="onSave()" [disabled]="commentControl.invalid">Save</button>
</mat-dialog-actions>
